import React, {Component} from "react";
import "./UserInformation.css";
import {FormattedMessage} from "react-intl";
import CustomerOrderTable from "./CustomerOrderTable/CustomerOrderTable";
import axios from "axios";
import {GOOGLE_ANALYTICS_CODE, RESOURCE_BASE_URL} from "../../../configuration";
import {Link} from "react-router-dom";
import UserAddressTable from "../../Site/UserProfile/UserAddressTable/UserAddressTable";
import UserAddressList from "./UserAddressList";
import ReactGA from "react-ga";


class UserInformation extends Component {
    constructor(props) {
        super(props);
        this.state = {
            japaneseFirstName : "",
            japaneseLastName : "",
            registeredDate : "",
            name: "",
            username : "",
            email: "",
            primaryAddress: "",
            phone: "",
            shippingAddressId: "",
            billingAddressId: "",
            shippingAddress: [],
            billingAddress: [],
            country: ""
        };
    }

    getCustomerInfo() {
        axios.get(RESOURCE_BASE_URL + 'api/users/' + this.props.match.params.id)
            .then((res) => {
                console.log("rrrrr 1 ",res.data);
                this.setState({
                    name: res.data.name,
                    email: res.data.email,
                    phone: res.data.phone,
                    username: res.data.username,
                    primaryAddress: res.data.primaryAddress,
                    billingAddressId: res.data.billingAddressId,
                    shippingAddressId: res.data.shippingAddressId,
                    shippingAddress: res.data.shippingAddress,
                    billingAddress: res.data.billingAddress,
                    japaneseFirstName: res.data.japaneseFirstName,
                    japaneseLastName: res.data.japaneseLastName,
                    registeredDate : res.data.registeredDate

                });
                console.log("rrrrr 2 ",res.data);
                {
                    // console.log("rrrrr 3", this.state.phone)
                }
            })
            .catch((err) => {
                console.log("[API] ERROR: ", err);
            });

    }

    componentDidMount() {
        this.getCustomerInfo();
    }

    render() {
        ReactGA.initialize(GOOGLE_ANALYTICS_CODE);
        ReactGA.pageview(window.location.pathname + window.location.search);
        return (
            <div className="user-info-content">
                <div className="user-info-div">
                    <div className="row">
                        <div className="col-md-8">
                            <div className="title-1">
                                <FormattedMessage id="app.admin.user.info.title"
                                                  defaultMessage="CUSTOMER :"
                                                  description=""/>
                                <span>{this.state.email}</span>
                            </div>
                        </div>
                        {/*<div className="col-md-4">*/}
                        {/*<div className="pull-right">*/}
                        {/*<Link to={"/admin/inquiries/perUser/" + this.props.match.params.id} className="btn btn-xs btn-success">*/}
                        {/*<FormattedMessage id="app.admin.user.info.enquiries"*/}
                        {/*defaultMessage="View Enquiries"*/}
                        {/*description=""/>*/}
                        {/*</Link>*/}
                        {/*</div>*/}
                        {/*</div>*/}

                    </div>
                    <hr className="upper-hr-cus-info"/>

                    <div className="row">
                        <div className="col-md-6">
                            <div className="row no-padding">
                                {/*    <label className="view-user-info-label">
                                    <FormattedMessage id="app.admin.customer.info"
                                                      defaultMessage="Customer Information "
                                                      description=""/>
                                </label>*/}
                            </div>
                            <div className="row">

                                <div>
                                    <label className="view-details-body-label">
                                        登録日
                                        :&nbsp; </label>
                                    {this.state.registeredDate}
                                </div>
                                <div>
                                    <label className="view-details-body-label">
                                        ユーザー名
                                        :&nbsp; </label>
                                    {this.state.username}
                                </div>
                                <div>
                                    <label className="view-details-body-label">
                                        <FormattedMessage id="app.user-profile.user-profile-info.name"
                                                          defaultMessage="Name"
                                                          description=""/>:&nbsp; </label>
                                    {this.state.japaneseLastName + " " + this.state.japaneseFirstName}
                                </div>
                                <div>
                                    <label className="view-details-body-label">
                                        <FormattedMessage id="app.user-profile.user-profile-info.email"
                                                          defaultMessage="Email"
                                                          description=""/>:&nbsp; </label>
                                    {this.state.email}
                                </div>
                                <div>
                                    <label className="view-details-body-label">
                                        <FormattedMessage id="app.user-profile.user-profile-info.phone"
                                                          defaultMessage="Phone"
                                                          description=""/>:&nbsp; </label>
                                    {this.state.phone}
                                </div>

                            </div>

                            <br/>

                        </div>
                        <div className="col-md-3">
                            <label className="view-user-info-label">
                                <FormattedMessage id="app.admin.customer.info.bill-address"
                                                  defaultMessage="Billing Address "
                                                  description=""/>
                            </label>
                            {this.state.billingAddress !== null ?
                                <div>
                                    <div>{this.state.billingAddress.lastName}&nbsp; {this.state.billingAddress.firstName}</div>
                                    <div>{this.state.billingAddress.postalCode}</div>
                                    <div>{this.state.billingAddress.addressLine2}</div>
                                    <div>{this.state.billingAddress.city}</div>
                                    <div>{this.state.billingAddress.province}</div>
                                    <div>{this.state.billingAddress.streetAddress}</div>
                                    <div>{this.state.country}</div>
                                    <div>{this.state.billingAddress.billContact}</div>
                                    <br/>
                                </div> :
                                <div><i>
                                    <small>請求先住所が設定されていません</small>
                                </i></div>
                            }

                        </div>
                        <div className="col-md-3">
                            <label className="view-user-info-label">
                                <FormattedMessage id="app.admin.user.info.shipping.address"
                                                  defaultMessage="Shipping Address "
                                                  description=""/></label>
                            {this.state.shippingAddress !== null ?
                                <div>
                                    <div>{this.state.shippingAddress.lastName}&nbsp; {this.state.shippingAddress.firstName}</div>
                                    <div>{this.state.shippingAddress.postalCode}</div>
                                    <div>{this.state.shippingAddress.addressLine2}</div>
                                    <div>{this.state.shippingAddress.city}</div>
                                    <div>{this.state.shippingAddress.province}</div>
                                    <div>{this.state.shippingAddress.streetAddress}</div>
                                    <div>{this.state.country}</div>
                                    <div>{this.state.shippingAddress.billContact}</div>
                                </div> :
                                <div><i>
                                    <small>配送先住所が設定されていません</small>
                                </i></div>
                            }


                        </div>
                    </div>


                    <div className="row">
                        <div className="col-md-12">
                            <label className="view-user-info-label">
                                {/*<FormattedMessage id="app.admin.user.info.orders"
                                                  defaultMessage="Orders"
                                                  description=""/>*/}
                                <FormattedMessage id="app.admin.user.info.all-address"
                                                  defaultMessage="All Addresses"
                                                  description=""/>
                            </label>
                            <hr/>

                            {/*<CustomerOrderTable userId={this.props.match.params.id}/>*/}
                            {/*<div className="admin-table-header-responsive">*/}
                                {/*<div className="admin-table-scroll">*/}
                                    <UserAddressList userId={this.props.match.params.id}/>
                                {/*</div>*/}
                            {/*</div>*/}
                        </div>
                    </div>
                    <br/>
                    <div className="row">
                        <div className="pull-right back-btn-info-margin-right" >
                            <Link to={"/admin/customers/all"} className="">
                                <FormattedMessage id="app.admin-info.back"
                                                  defaultMessage="<< Back"
                                                  description=""/>
                            </Link>
                        </div>
                    </div>
                </div>

            </div>
        );
    }
}

export default UserInformation;



// WEBPACK FOOTER //
// ./src/components/Admin/Customer/UserInformation.js